import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { emit } from 'process';

@Component({
  selector: 'app-export-viewer',
  templateUrl: './export-viewer.component.html',
  styleUrls: ['./export-viewer.component.scss']
})
export class ExportViewerComponent implements OnInit {

  constructor() { }
  @Input() headerVal: string = 'Data Export';
  @Input() exportView: boolean = false;
  @Input() url: string = '';
  @Input() errorBool: boolean = false;
  @Output() closeExport = new EventEmitter();
  ngOnInit(): void {
  }

  @Output() downloadDocument = new EventEmitter();

  download() {
    window.open(this.url, "_blank");
    this.exportView = false;
    this.url = '';
    this.closeExport.emit(false);
  }

  closeExportWindow() {
    this.closeExport.emit(false);
    this.exportView = false;
    this.url = '';
    this.errorBool = false;
  }

}

